import { Row } from '@tanstack/react-table'
import styles from '../../CombinedLogs.module.scss'
import { Log } from '@/types/logs'

interface HandoverSeparatorProps {
    isAfter?: boolean
    rowIndex: number
    array: Row<Log>[]
}

export const HandoverSeparator = ({ isAfter = false, rowIndex, array }: HandoverSeparatorProps) => {
    if (
        !isAfter &&
        rowIndex > 0 &&
        array[rowIndex].original.code === 'HO' &&
        array[rowIndex - 1].original.code !== 'HO'
    )
        return <tr className={styles.handoverSeparator} />

    if (
        isAfter &&
        rowIndex < array.length - 1 &&
        array[rowIndex].original.code === 'HO' &&
        array[rowIndex + 1].original.code !== 'HO'
    )
        return <tr className={styles.handoverSeparator} />

    return null
}
